import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { usePageHeader } from '@/layouts/PageHeaderProvider.tsx'
import { useEffect } from 'react'
import HistoryView from '../../applicants/applicant_details/HistoryView.tsx'
import { ProviderQueries } from '@/queries/providers/queries'
import { RootState } from '@/storage/store'
import { useSelector } from 'react-redux'
import { historyType } from '@/app/common/constants'

export default function ProvidersHistoryView() {
  const { setTitle } = usePageHeader()
  const { providerId } = useParams<{ providerId?: string }>()
  const { selectedProgramYear } = useSelector((s: RootState) => s.programs)

  if (!providerId) {
    throw new Error('ProviderId Not found')
  }

  const providerQueryOptions = ProviderQueries.getProviderById(
    selectedProgramYear?.id ?? 0,
    providerId
  )
  const { data: providerInfo, error } = useQuery({
    ...providerQueryOptions,
    enabled: !!providerId,
  })

  useEffect(() => {
    if (providerInfo?.name) {
      setTitle(`${providerInfo.name}`)
    }
  }, [providerInfo?.name])

  if (error) {
    return <div>{error?.message ?? ''}</div>
  } else if (providerInfo?.name) {
    return (
      <HistoryView
        user_id={parseInt(providerId!)}
        user_type_id={historyType.provider}
      />
    )
  } else {
    return <></>
  }
}
